<div class="modal-header">
  <h4 class="modal-title pull-left">{{titre}}</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="fermerModale()" title="{{'GLOBAL.FERMER' | translate}}">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p>{{resultat}}</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-success" (click)="fermerModale()">{{'GLOBAL.FERMER' | translate}}</button>
</div>
